import React from 'react';
import { Card } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';
// import { Container } from 'react-bootstrap';
import './Products.css';

import prodsensorbg from '../images/PageImg/ProductSensor-page-bg.jpg'
import HeaderSlide from '../components/HeaderSlide'
import { SensorDitoImg } from "../assets/ProductSensorData";
import { SensorFFImg } from "../assets/ProductSensorData";
import { SensorFogImg } from "../assets/ProductSensorData";

import { SensorDitoTxt } from "../assets/ProductSensorData";
import { SensorFogTxt } from "../assets/ProductSensorData";
import { SensorFFTxt } from "../assets/ProductSensorData";

import { GoTopBtn } from '../components/GoTopBtn';

function ProductSensor() {
  // console.log("get into ProductSensor()");
  return (
    <div className='products-page container-fluid'>
      <div images className='productheader'
        style={{ backgroundImage: `url(${prodsensorbg})`, height: 'auto' }} >
        <HeaderSlide text={'Product / Sensor'} />
        <h4 className='text-light'>&nbsp;images/PageImg/ProductSensor-page-bg.jpg</h4>
      </div>
      {/* <br /> */}

      {/* Product PCap DITO Glass Sensor */}
      <section id='productsensordito' className='product-block bg-warning-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-success'>PCap DITO Sensor</h2>
        {/* <Container fluid> */}
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            SensorDitoImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '50vw' }} alt='' /> */}
                  <h5 className='text-primary-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            // <Row> {
            SensorDitoTxt.map((dito) => {
              return (
                <Row key={dito.id} style={{ marginLeft: '-25px', width: '57.5vw' }}>
                  <Card className='bg-primary-subtle border-1'>
                    <br />
                    <Card.Title className='text-center fs-3 text-primary'> {dito.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {dito.text} </Card.Text>
                    {/* <Card.Text className='fs-4' style={{ whiteSpace: 'pre' }}> {dito.text} </Card.Text> */}
                  </Card>
                </Row>
              )
            })
            // } </Row>
          } </Col>
        </Row>
        {/* </Container> */}
      </section>

      {/* Product PCap Film Sensor */}
      <section id='productsensorff' className='product-block bg-info-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-primary'>PCap Film Sensor</h2>
        <Row>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            SensorFFTxt.map((ff) => {
              return (
                <Row key={ff.id} className='holder'>
                  <Card className='bg-warning-subtle border-1' style={{ marginLeft: '11px' }}>
                    <br />
                    <Card.Title className='text-center fs-3 text-success'> {ff.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {ff.text} </Card.Text>
                    {/* <Card.Text className='fs-4' style={{ whiteSpace: 'pre' }}> {ff.text} </Card.Text> */}
                  </Card>
                </Row>
              )
            })
          } </Col>
          <Col lg={5} className='flex-column justify-content-center'> {
            SensorFFImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '60vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
        </Row>
      </section>

      {/* Product PCap Fog Sensor */}
      <section id='productsensorfog' className='product-block bg-warning-subtle'>
        <h2 className='title-holder fs-1 fw-bold text-success'>PCap FOG Sensor</h2>
        <Row>
          <Col lg={5} className='flex-column justify-content-center'> {
            SensorFogImg.map(idx => {
              return (
                <Row key={idx.id} className='d-flex'>
                  <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
                  {/* <img src={idx.image} style={{ width: '60vw' }} alt='' /> */}
                  <h5 className='text-warning-emphasis'>{idx.alt}</h5>
                </Row>
              );
            })
          } </Col>
          <Col lg={7} className='d-flex flex-column justify-content-around'> {
            SensorFogTxt.map((fog) => {
              return (
                <Row key={fog.id} style={{ marginLeft: '-25px', width: '57.5vw' }}>
                  {/* <Row key={tdm.id} className='holder' style={{ marginLeft: '-25px' }}> */}
                  <Card className='bg-primary-subtle border-1 p-0 m-0'>
                    <br />
                    <Card.Title className='text-center fs-3 text-primary'> {fog.title} </Card.Title>
                    <Card.Text style={{ whiteSpace: 'pre' }}> {fog.text} </Card.Text>
                  </Card>
                </Row>
              )
            })
          } </Col>
        </Row>
      </section>

      <div> < GoTopBtn /> </div>
    </div>
  )
}

export default ProductSensor;

// import { SensorTopImg } from "../assets/ProductSensorData";
// {/* Product Sensor Top Image */}
// <section id='productsensortop' className='block product-block bg-success-subtle'> {
//   <Row className='d-flex justify-content-around'> {
//     SensorTopImg.map(idx => {
//       return (
//         <Col lg={4} key={idx.id} className='flex'>
//           <img src={idx.image} className='img-fluid' style={{ height: 'auto' }} alt='' />
//           // <img src={idx.image} style={{ height: '65vh', width: '55vw' }} alt='' />
//           <h5 className='text-warning-emphasis'>{idx.alt}</h5>
//         </Col>
//       )
//     })
//   } </Row>
// } </section>
